import React, { PureComponent } from 'react';
import 'react-table/react-table.css';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import IconCSV from './assets/Icon_CSV.svg';

const StyledDownloadComponent = styled.div`
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
`;

const ContentWrapper = styled.div`
  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  color: #42515a;
  margin-bottom: 20px;
  position: relative;
  display: grid;
  padding: 1em;
`;

const ListWraper = styled.div`
  grid-column: span 3;
  @media (min-width: 680px) {
    grid-column: span 3;
  }
`;

const StyledList = styled.div``;

const StyledOL = styled.ol`
  -moz-column-count: 3;
  -moz-column-gap: 20px;
  -webkit-column-count: 3;
  -webkit-column-gap: 20px;
  column-count: 3;
  column-gap: 20px;
}`;

const StyledH4 = styled.h4`
  color: grey;
`;

const BottomSectionWrapper = styled.div`
  padding: 20px 22px;
`;

const DownloadFileWrapper = styled.div`
  grid-column: span 3;
  @media (min-width: 380px) {
    grid-column: span 3;
  }
  display: inline-block;
`;

const StyledIcon = styled.img`
  width: 40px;
  height: 40px;
  display: inline-block;
`;

const LastDataWrapper = styled.div`
  font-size: 12px;
  color: #6d7b80;
  vertical-align: bottom;
  width: 150px;
  padding: 0 0 5px 12px;
  display: inline-block;
`;

const StyledButton = styled.button`
  display: inline-block;
  color: white;
  background-color: #2cc4f4;
  border-color: none;
  border: 0;
  font-size: 0.8em;
  padding: 0.8em 1.2em;
  border-radius: 5px;
  cursor: pointer;
  font-family: latoregular;
`;

const ButtonWrapper = styled.div`
  padding: 0px;
  float: right;
  margin-right: 20px;
  margin-top: 10px;
`;

class DownloadComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  creatFieldListItems() {
    const data = JSON.parse(this.props.data);
    let fields = data.fields[0].All;
    let output = [];

    fields.forEach(element => {
      // TODO Categorize and put Headings
      output.push(<li key={element.Field}>{element.DETranslation}</li>);
    });

    return output;
  }

  render() {
    const { title, info } = this.props;

    return (
      <StyledDownloadComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <ContentWrapper>
          <BottomSectionWrapper>
            <DownloadFileWrapper>
              <StyledIcon src={IconCSV} alt="csv" />
              <LastDataWrapper>Stand {this.props.lastUpdated}</LastDataWrapper>
            </DownloadFileWrapper>

            <ButtonWrapper>
              <a
                href={
                  '/api/v1/customer_details/all/' + this.props.id + '?type=csv'
                }
                target="blank"
              >
                <StyledButton>Download </StyledButton>
              </a>
            </ButtonWrapper>
          </BottomSectionWrapper>

          <ListWraper>
            <StyledH4>Enthaltene Attribute</StyledH4>
            <StyledList>
              <StyledOL>{this.creatFieldListItems()}</StyledOL>
            </StyledList>
          </ListWraper>
        </ContentWrapper>
      </StyledDownloadComponent>
    );
  }
}

export default DownloadComponent;
